import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    lead: null,
    reseller: null,
    isEngineeringLead: false,
  },
  mutations: {
    setLead(state, response) {
      state.lead = response;
    },
    setReseller(state, response) {
      state.reseller = response;
    },
    setIsEngineeringLead(state, response) {
      state.isEngineeringLead = response;
    },
  },
  actions: {
    setLead({ commit }, params) {
      commit('setLead', params.lead);
      commit('setReseller', params.reseller);
      commit('setIsEngineeringLead', params.isEngineeringLead);
    },
  },
});

export default store;